export function Field({ label, hint, children }) {
  return (
    <div>
      <label className="text-[11px] text-neutral-500 block mb-1">{label}</label>
      {children}
      {hint && <div className="text-[10px] text-neutral-600 mt-1">{hint}</div>}
    </div>
  );
}

export function TextIn({ value, onChange, testid, type = "text", ...rest }) {
  return (
    <input type={type} className="w-full px-2.5 py-1.5 rounded border text-sm" value={value ?? ""}
      onChange={(e) => onChange(type === "number" ? (e.target.value === "" ? "" : Number(e.target.value)) : e.target.value)}
      data-testid={testid} {...rest} />
  );
}

export function Toggle({ checked, onChange, label, testid }) {
  return (
    <label className="flex items-center gap-2 text-xs cursor-pointer select-none">
      <input type="checkbox" checked={!!checked} onChange={(e) => onChange(e.target.checked)} data-testid={testid} />
      <span>{label}</span>
    </label>
  );
}
